/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import cloneDeep from 'lodash/cloneDeep';

import { compareForm, getFormCreatedMetadata, sendFormFieldsMetadata } from '../../../shared/mixpanel';
import { autocompleteQuotaStatus } from '../reducers/fieldSettings';
import autosave from '../builder_utils/localStorage';
import uploader from '../../../shared/uploader';
import { inventoryControls } from './element';
import { doSaveCtrl } from './editbar';
import win from '../../../shared/win';

import {
  InputType,
  ctrlErrors,
  ControlType,
  prepareForm,
  ctrlDefaults,
  checkWideForm,
  formAmendForm,
  dataURItoBlob,
  formHasControls,
  planSupportField,
  ammendBuilderForm,
  pageReorderControl,
  getImageDimensions,
  generateBuilderForm,
  paymentControlTypes,
  convertToStorableClosingPages,
} from '../../../shared/form-lib';

import {
  clearForm,
  savingForm,
  showFieldError,
  fetchFormStart,
  doSetUpNewForm,
  updateAutoSave,
  fetchPDFSuccess,
  fetchFormSuccess,
  fetchFormFailure,
  showBuilderError,
  doSaveUserOptions,
  setupSavedLocalForm,
  setRedirectToCustomise,
  setIsBuilderFormUpdated,
  doShowFormControlsModal,
  doShowQuotaExceededModal,
  indicateFormDeactivation,
  disablePaymentUserSpecify,
} from '../reducers/builder';

import {
  saveAction,
  updatePlan,
  checkUserVm,
  externalSave,
  showFormError,
  disableHandler,
  updateCredential,
  doShowFormNameModal,
  showClearPremiumModal,
  checkPaymentCredentials,
  paymentCredentialMissingModal,
} from '../reducers/form-validations';

import {
  apiCommon,
  fplsFetch,
  getPDFForm,
  newIdentifier,
  urlTestPattern,
  htmlToPlainText,
  generateFileInfo,
  isArrayValuesUnique,
  cleanFormInputFromXSS,
  logErrorToCloudReporting
} from '../../../shared/utils';

export const quotaHandler = (response) => (dispatch) => {
  const formsLeft = response.forms_left === 'inf' ? Infinity : parseInt(response.forms_left, 10);

  if (formsLeft > 0) return false;

  const errorText = 'You have used up your monthly form quota.';
  const metadata = {
    plan_name: win.PLAN.name,
  };
  window.Intercom('trackEvent', 'exceeded-form_quota', metadata);
  dispatch(showBuilderError(errorText));
  return true;
};

export const checkAddresAutoCompletionQuota = () => async (dispatch) => {
  try {
    const response = await fplsFetch({ url: '/api/v2/user/quota' });
    dispatch(autocompleteQuotaStatus(response.address_autocompletion));
  } catch (error) {
    console.error('Error while loading user quota info. Details:', error);
  }
};

export const checkQuotas = () => async (dispatch) => {
  let exceeded = true;
  try {
    const response = await fplsFetch({ url: '/api/v2/user/quota' });
    exceeded = dispatch(quotaHandler(response));
  } catch (error) {
    const errorText = "You don't have permission to create form ";
    dispatch(showBuilderError(errorText));
    console.error('Error while loading user info. Details:', error);
  }
  return exceeded;
};

const uploadPDFImgToServer = async (dataUrl, name) => {
  const uploaderInstance = new uploader();
  const file = dataURItoBlob(dataUrl);
  const contentType = file.type;
  file.name = name;
  const promise = new Promise(async function (resolve) {
    const response = await fplsFetch({ url: `/attachment/images?mimetype=${contentType}` });
    if (response.error) {
      console.error('uploadPDFImgToServer.get error: ', response.error);
      resolve('');
    } else {
      const dim = await getImageDimensions(dataUrl);
      const imgData = {
        width: dim.w,
        height: dim.h,
      };
      const { blob_name, upload_url } = response;
      uploaderInstance.addFiles([file]);
      uploaderInstance.startUpload({
        url: upload_url,
        headers: { 'Content-Type': contentType },
        method: 'PUT',
        concurrency: 1,
        type: 'File',
        data: imgData,
        async onCompleted() {
          const fileInfo = generateFileInfo(blob_name, file);
          Object.assign(fileInfo, imgData);
          const validationResp = await fplsFetch({
            url: '/attachment/images',
            data: { file_info: fileInfo },
            method: 'POST',
          });
          if (validationResp.error) {
            console.error('uploadPDFImgToServer.validate error: ', validationResp.error);
            resolve('');
          } else {
            try {
              localStorage.setItem(name, validationResp.url);
            } catch (err) {
              console.error('Saving PDF image name Localstorage Error', err);
              resolve('');
            }
            resolve(validationResp.url);
          }
        },
        onError() {
          console.error('uploadPDFImgToServer.uploading error');
          resolve('');
        },
      });
    }
  });
  return promise;
};

export const fetchUserOptions = () => async (dispatch) => {
  try {
    const response = await fplsFetch({ url: `/api/v2/user/options` });
    dispatch(doSaveUserOptions(response));
  } catch (error) {
    console.error('Error fetching user options:', error);
  }
};

export const updateOnboardedStatus = (status) => async (dispatch, getState) => {
  const {
    present: { form },
  } = getState().builder;

  const msg = 'Encountered error while updating user onboarding status';

  try {
    const response = await fplsFetch({
      url: '/api/v2/user/options',
      method: 'PUT',
      data: {
        onboarded_v2: true,
      },
    });

    if (response.error) {
      console.error(msg);
    } else {
      const formId = form?.id || '_NEW_';
      const {
        location: { protocol, hostname, port },
        PLAN: { name },
      } = win;
      const metadata = {
        form_id: formId,
        plan_name: name,
        form_url: `${protocol}//${hostname}:${port}/form/${formId}`,
      };
      window.Intercom('trackEvent', status ? 'watched-builder-v2-tour' : 'skipped-builder-v2-tour', metadata);
    }
  } catch (error) {
    console.error(msg);
  }
};

export const fetchTrueForm = async (formId) => {
  try {
    const trueForm = await fplsFetch({ url: `/api/v2/user/form/${formId}` });

    if (trueForm?.error) {
      console.error('Error fetching form');
      return false;
    }

    return trueForm;
  } catch (error) {
    console.error('Error fetching form:', error);
    return false;
  }
};

export const doFetchSavedForm = (json, isAutosave, formId) => {
  return (dispatch) => {
    if (json.error) {
      const notFoundMsg = 'Requested form could not be found.';
      const failedGetMsg =
        'An error has occurred when attempting to ' +
        'retrieve this form. Please refresh & try again. You may also send ' +
        'an email to support@formpl.us if this persists';
      const error = json.error && json.status === 404 ? notFoundMsg : failedGetMsg;
      dispatch(fetchFormFailure({ error, loading: false }));
      console.error('Fetch Form Error', error);
      logErrorToCloudReporting(error);
      toast.error(error);
    } else if (!isAutosave && prepareForm(json.definition)) {
      dispatch(
        fetchFormSuccess({
          form: formAmendForm(json),
          loading: false,
          isSavedForm: true,
        })
      );

      const metadata = {
        form_id: formId,
        form_url: `${window.location.protocol}://${window.location.hostname}:${window.location.port}/form/${formId}`,
        plan_name: win.PLAN.name,
      };

      window.Intercom('trackEvent', 'editing-form', metadata);
    } else {
      dispatch(setupSavedLocalForm(json));
    }
  };
};

export const doFetchTemplateForm = (json, templateId, isAutosave) => {
  return async (dispatch) => {
    if (isAutosave) dispatch(updateAutoSave({ status: true, autoSavedResponse: json }));
    if (json.error) {
      const notFoundMsg = 'Requested form could not be found.';
      const failedGetMsg = `An error has occurred when attempting to 
        retrieve this form. Please refresh & try again. You may also send 
        an email to support@formpl.us if this persists`;
      const error = json.error && json.status === 404 ? notFoundMsg : failedGetMsg;
      dispatch(fetchFormFailure({ error, loading: false }));
      console.error('Fetch Form Error', error);
      logErrorToCloudReporting(error);
      toast.error(error);
    } else if (prepareForm(json.definition, 2)) {
      dispatch(
        fetchFormSuccess({
          form: formAmendForm(json),
          isTemplateForm: true,
          editingForm: true,
          loading: false,
        })
      );
      const metadata = {
        plan_name: win.PLAN.name,
        template_id: templateId,
      };
      window.Intercom('trackEvent', 'using-template', metadata);
    }
  };
};

export const getInventoryProducts = async (formId, isPublic = false) => {
  const url = `/api/v2/${isPublic ? 'public' : 'user'}/${Number(formId)}/inventory_product/all`;
  try {
    const { products } = await fplsFetch({ url });
    return products;
  } catch (error) {
    console.log('An error occurred while fetching inventory products', error);
  }
};

export const updateFormInventoryProducts = async (form, formId, isPublic) => {
  if (!form?.definition?.pages) return form;
  let newForm = cloneDeep(form);
  let inventoryFieldData = null;

  newForm.definition.pages.forEach((page, pageIndex) => {
    page.controls.forEach((ctrl, ctrlIndex) => {
      if (ctrl.type === 'inventory_field') {
        inventoryFieldData = {
          pageIndex,
          ctrlIndex,
        };
      }
    });
  });

  if (inventoryFieldData) {
    const products = await getInventoryProducts(formId, isPublic);
    const { pageIndex, ctrlIndex } = inventoryFieldData;
    if (products) {
      newForm.definition.pages[pageIndex].controls[ctrlIndex].props.inventory_products = products;
    }
  }

  return newForm;
};

export const route2SavedForm = (formId) => async (dispatch) => {
  dispatch(fetchFormStart());

  let json = await fetchTrueForm(formId);

  if (!json || !json.definition) {
    const error = `An error occurred when retrieving this form. Please refresh and try again or email support@formpl.us if the issue persists.`;
    dispatch(fetchFormFailure({ error, loading: false }));
    return;
  }

  const ctrlIdentifiers = generateBuilderForm(json)?.oldInternalIdentifiers;
  const isInventoryForm = Object.values(ctrlIdentifiers || {}).some(({ type }) => type === ControlType.INVENTORY);

  if (isInventoryForm) {
    json = await updateFormInventoryProducts(json, formId);
  }

  dispatch(doFetchSavedForm(json, false, formId));
};

export const route2NewForm = () => async (dispatch) => {
  const exceeded = await dispatch(checkQuotas());
  if (exceeded) return dispatch(doShowQuotaExceededModal(true));

  const { response: autoSavedResponse, needToConfirm } = await autosave.getSavedResponse(true);
  if (!autoSavedResponse) dispatch(doSetUpNewForm());

  if (needToConfirm) dispatch(updateAutoSave({ status: true, autoSavedResponse }));
};

export const autosaveAction = (restore) => (dispatch, getState) => {
  const { present } = getState().builder;
  const { isNewForm, isTemplateForm, autoSavedResponse } = present;

  if (restore) {
    if (isNewForm) {
      dispatch(updateAutoSave({ status: false }));
      dispatch(doSetUpNewForm(autoSavedResponse));
    } else if (isTemplateForm) {
      dispatch(setupSavedLocalForm(autoSavedResponse));
    }
    return;
  }

  if (isNewForm) {
    dispatch(doSetUpNewForm());
    autosave.saveResponse(present);
  } else {
    dispatch(updateAutoSave({ status: false }));
  }
};

export const route2TemplateForm = (templateId) => async (dispatch) => {
  const { response: autoSavedResponse, needToConfirm } = await autosave.getSavedResponse(true, templateId);
  dispatch(fetchFormStart());
  if (autoSavedResponse && needToConfirm) {
    dispatch(doFetchTemplateForm(autoSavedResponse, templateId, true));
  }
  const exceeded = await dispatch(checkQuotas());
  if (exceeded) return;
  const json = await fplsFetch({ url: `/api/v2/public/templates/${templateId}` });
  dispatch(doFetchTemplateForm(json, templateId, false));
};

export const doCheckPaymentCredentials = () => (dispatch) => {
  fplsFetch({ url: '/api/v2/user/credentials' })
    .then((response) =>
      dispatch(
        checkPaymentCredentials({
          stripe_credentials: JSON.parse(response.stripe_credentials),
          flutterwave_credentials: JSON.parse(response.flutterwave_credentials),
          paypal_credentials: JSON.parse(response.paypal_credentials),
          paystack_credentials: JSON.parse(response.paystack_credentials),
        })
      )
    )
    .catch((error) => console.error('Payment Credential Error', error));
};

export const doClearForm = () => (dispatch, getState) => {
  const { builderForm } = getState().builder.present;
  const hasCtrls = formHasControls(builderForm);
  if (hasCtrls) dispatch(doShowFormControlsModal(true));
  else dispatch(clearForm());
};

export const checkCred = (type) => (dispatch, getState) => {
  const { vm, stripe_credentials, flutterwave_credentials, paypal_credentials, paystack_credentials } =
    getState().formValidations;
  const ctrlMap = {
    stripe: stripe_credentials,
    flutterwave: flutterwave_credentials,
    paypal: paypal_credentials,
    paystack: paystack_credentials,
  };
  const credentials = ctrlMap[type];
  const paymentType = `${type.charAt(0).toUpperCase()}${type.substr(1)}`;

  const isCredentialMissing = () => {
    return (
      !credentials ||
      (type === 'stripe' && !credentials.stripe_user_id) ||
      (type === 'flutterwave' && (!credentials.public_key || !credentials.private_key)) ||
      (type === 'paypal' && !(credentials.client_id || credentials.test_client_id)) ||
      (type === 'paystack' && !(credentials.public_key || credentials.test_public_key))
    );
  };

  if (isCredentialMissing() && !vm.missing_credentials.includes(paymentType)) {
    dispatch(
      checkUserVm({
        missing_credentials: [...vm.missing_credentials, paymentType],
        showNag: true,
        authorizePaymentNag: true,
      })
    );
  }
};

export const checkFormHasPaymentField = () => (dispatch, getState) => {
  const {
    builder: {
      present: { builderForm: form },
    },
    formValidations: { vm },
  } = getState();
  const { pages, pageIds } = form;
  const paymentCtrls = [];

  pages.forEach((page, index) => {
    pageIds[index].forEach((id, idx) => {
      const fieldId = pageIds[index][idx];
      const ctrl = pages[index][Number(fieldId)];
      // check for payment fields in form and if they have credentials
      if (vm.fields.includes(ctrl.type)) {
        paymentCtrls.push(ctrl);
        dispatch(checkCred(ctrl.type));
      }
    });
  });

  // disable user specify for payments fields as applicable
  if (paymentCtrls.length > 0) {
    dispatch(disablePaymentUserSpecify(paymentCtrls));
  }
};

const checkPaymentFields = () => (dispatch, getState) => {
  const {
    builder: {
      present: { builderForm },
    },
  } = getState();

  return builderForm.pages.some((page) => {
    return Object.values(page).some((control) => paymentControlTypes.includes(control.type));
  });
};

export const doHandleExternalSave = (formId) => async (dispatch, getState) => {
  const {
    redirectToCustomise: { status },
    isSavedForm,
  } = getState().builder.present;

  dispatch(externalSave({ isSaving: false, newFormId: formId }));
  const { inventory_field } = dispatch(inventoryControls());
  if (!isSavedForm) dispatch(route2SavedForm(formId));
  dispatch(savingForm(false));

  if (inventory_field) {
    const {
      props: { deleted_inventory_product_ids, inventory_products },
      internal_id,
    } = inventory_field;
    const isAnyNewProduct = inventory_products.some(({ id }) => !id);

    if (deleted_inventory_product_ids.length) {
      // Clear deleted inventory product ids to prevent inventory product quota from being deducted falsely.
      // This prevent product quota deductions from leading to negative values.
      dispatch(doSaveCtrl([], internal_id, 'deleted_inventory_product_ids'));
    }

    if (isAnyNewProduct) {
      // Fetch and update inventory products in case user wants to delete a product,
      // their ids will be available for sending to the backend.
      const updatedProducts = await getInventoryProducts(formId);
      if (updatedProducts) dispatch(doSaveCtrl(updatedProducts, internal_id, 'inventory_products'));
    }
  }

  if (status === 'requested') {
    autosave.deleteSavedResponse();
    dispatch(setRedirectToCustomise({ status: 'yes' }));
  }

  if (status === 'no') {
    toast.success(`Your changes have been saved! Click on "Next" button to customise your form.`);
  }
};

const fieldError = 'Incorrect Field Option';
const errorMsgPageMultiple = (pages) =>
  `You seem to have made errors while creating fields. Please look at page ${pages} to correct them. If you keep getting this message please contact support@formpl.us`;
const errorMsgPageOnce = (pages) =>
  `It seems you made errors while creating some fields, please look at page ${pages} to correct them.`;

export const doSuccess = (response, id) => (dispatch, getState) => {
  const {
    builder: {
      present: { builderForm, form },
    },
  } = getState();
  let mixpanelData;
  let fieldIds;
  let formPages;
  let reversed;
  let newFormId;
  let metadata;

  if (response.form_id) {
    newFormId = response.form_id;
    metadata = {
      form_id: newFormId,
      form_url: `${window.location.protocol}://${window.location.hostname}:${window.location.port}/form/${newFormId}`,
      plan_name: win.PLAN.name,
    };

    try {
      mixpanelData = getFormCreatedMetadata(builderForm.pages, builderForm.name, newFormId);
      fieldIds = mixpanelData[1];
      window.mixpanel.track('Created Form', mixpanelData[0]);
      sendFormFieldsMetadata(builderForm, fieldIds);
    } catch (error) {
      console.error('Mixpanel Error', error, error);
    }

    window.Intercom('trackEvent', 'created-form', metadata);
    // Todo:  Integrate mixpanel and intercom into new-builder for nnew forms saving
    // Todo: Ask backend bros for user plan
  } else {
    metadata = {
      form_id: id,
      form_url: `${window.location.protocol}://${window.location.hostname}:${window.location.port}/form/${id}`,
      plan_name: win.PLAN.name,
    };
    // Todo:  Integrate mixpanel and intercom into new-builder for editing forms
    try {
      formPages = compareForm(form.definition, builderForm).pages;
      mixpanelData = getFormCreatedMetadata(formPages, form.name, metadata.form_id);
      fieldIds = mixpanelData[1];

      if (fieldIds.length === 0) {
        reversed = true;
        formPages = compareForm(form.definition, builderForm, reversed).pages;
        mixpanelData = getFormCreatedMetadata(formPages, form.name, metadata.form_id);
        fieldIds = mixpanelData[1];
      }

      window.mixpanel.track('Edited Form', mixpanelData[0]);
      sendFormFieldsMetadata(builderForm, fieldIds, reversed);
    } catch (error) {
      console.error('Mixpanel Error:', error, error);
    }

    window.Intercom('trackEvent', 'edited-form', metadata);
  }

  dispatch(doHandleExternalSave(response.form_id ?? id));
};

export const showMarshalError = (marshalErrors, fullForm) => (dispatch, getState) => {
  const { internalIdentifiers } = getState().builder.present;
  if (!marshalErrors.length) return;
  let errShownCount = 0;
  const highlighted = new Set();
  let errorPages = new Set();
  const errorCtrls = [];
  const errorMsgFields = (pags) => (errShownCount ? errorMsgPageMultiple(pags) : errorMsgPageOnce(pags));
  const backendForm = fullForm.definition;
  dispatch(disableHandler());
  for (let i = 0; i < marshalErrors.length; i += 1) {
    const [pageIndex, ctrlIndex] = marshalErrors[i].match(/\d{1,}/g);

    if (ctrlIndex) {
      const errPage = backendForm.pages[pageIndex];
      let errCtrl = errPage.controls[ctrlIndex];
      const { internal_id } = errCtrl;
      if (highlighted.has(internal_id)) continue;
      // Todo replace with internalIdentifiers
      errCtrl = internalIdentifiers[internal_id];
      errCtrl._validationError = fieldError;
      highlighted.add(internal_id);
      errorPages.add(Number(pageIndex) + 1);
      errorCtrls.push(errCtrl);
    }
  }
  errorPages = [...errorPages];
  errorPages = errorPages.join(', Page ');

  const errors = errorMsgFields(errorPages);
  dispatch(showFormError({ formError: errors }));
  errShownCount += 1;
};

export const doError = (error, fullForm) => (dispatch, getState) => {
  const { form } = getState().builder.present;
  console.error(`Error while saving form (id:${form.id}). Details:`, error);
  dispatch(savingForm(false));
  const genericMsg =
    '[#6] An error has occurred while saving your ' +
    'form. Please chat with us or contact support@formpl.us ' +
    'about this error';

  const errorMsg = error.data?.message;
  let marshalErrors = error.data?.errors;
  if (!marshalErrors) {
    const errorText = errorMsg || genericMsg;
    dispatch(showFormError({ formError: errorText }));
  }
  try {
    marshalErrors = Object.keys(marshalErrors);
  } catch {
    marshalErrors = [];
  }
  showMarshalError(marshalErrors, fullForm);
};

const validateNumberCtrl = (props, colIdx = null) => {
  const count = (n) => (n ? String(Math.abs(n)).length : n); // get number character count

  const setError = (error) => `${error} ${colIdx ? `(Check column ${colIdx})` : ''}`;

  if (props.min_count && props.max_count) {
    if (props.min_count > props.max_count) {
      return setError(ctrlErrors.minmax_count);
    }
  }

  if (props.min_acceptable && props.max_acceptable) {
    if (props.min_acceptable > props.max_acceptable) {
      return setError(ctrlErrors.minmax_acceptable);
    }

    // if (props.min_acceptable === props.max_acceptable) {
    //    return setError(ctrlErrors.min_acceptable_equals_max);
    // }
  }

  if (props.min_acceptable && props.min_count) {
    if (count(props.min_acceptable) < props.min_count) {
      return setError(ctrlErrors.min_acceptable_less_min_count);
    }
  }

  if (props.max_acceptable && props.min_count) {
    if (count(props.max_acceptable) < props.min_count) {
      return setError(ctrlErrors.max_acceptable_less_min_count);
    }
  }

  if (props.min_acceptable && props.max_count) {
    if (count(props.min_acceptable) > props.max_count) {
      return setError(ctrlErrors.min_acceptable_greater_max_count);
    }
  }

  if (props.max_acceptable && props.max_count) {
    if (count(props.max_acceptable) > props.max_count) {
      return setError(ctrlErrors.max_acceptable_greater_max_count);
    }
  }
};

export const validateCtrl = (ctrl) => (dispatch, getState) => {
  if (!ctrl) return;

  const { vm } = getState().formValidations;

  const isNumberCtrl =
    ctrl.type === ControlType.NUMBER ||
    ([
      ControlType.TEXT_INPUT,
      ControlType.SHORT_TEXT,
      ControlType.LABELED_INPUT,
      ControlType.APPENDED_TEXT,
      ControlType.PREPENDED_TEXT,
    ].includes(ctrl.type) &&
      ctrl.props.type === InputType.NUMBER);

  if (ctrl.props.default && isNumberCtrl && isNaN(Number(ctrl.props.default))) {
    return ctrlErrors.number_input;
  }

  if (!!ctrl.props.min_length && !!ctrl.props.max_length) {
    if (ctrl.props.min_length > ctrl.props.max_length) {
      return ctrlErrors.min_max;
    }
  }

  if (!!ctrl.props.min_selections || !!ctrl.props.max_selections) {
    const totalOptions = ctrl.props.other ? ctrl.props.options.length + 1 : ctrl.props.options.length;
    if (ctrl.props.min_selections > totalOptions) {
      return ctrlErrors.min_selection;
    }
    if (ctrl.props.max_selections > totalOptions) {
      return ctrlErrors.max_selection;
    }
  }

  if (!!ctrl.props.min_selections && !!ctrl.props.max_selections) {
    if (ctrl.props.min_selections > ctrl.props.max_selections) {
      return ctrlErrors.minselection_max;
    }
  }

  if (!!ctrl.props.min_word_length && !!ctrl.props.max_word_length) {
    if (ctrl.props.min_word_length > ctrl.props.max_word_length) {
      return ctrlErrors.max_word;
    }
  }

  // PHONE
  if (ctrl.props.phone_codes_limit && !!ctrl.props.phone_valid_codes) {
    if (ctrl.props.phone_valid_codes.length === 0) {
      return ctrlErrors.valid_phone;
    }
  }

  // PHONE
  // if (ctrl.props.phone_codes_limit && !!ctrl.props.phone_default_code) {
  //   if (ctrl.props.phone_valid_codes == null) ctrl.props.phone_valid_codes = [];
  //   if (ctrl.props.phone_valid_codes.indexOf(ctrl.props.phone_default_code) === -1) {
  //     ctrl.props.phone_valid_codes.push({ code: ctrl.props.phone_default_code });
  //   }
  // }

  if (ctrl.props.options) {
    if (ctrl.props.options.length === 0) {
      return ctrlErrors.no_options;
    }

    if (ctrl.props.weights && ctrl.props.option_values) {
      if (ctrl.type !== ControlType.SCALE_RATING) {
        if (ctrl.props.weights.length === 0) {
          return ctrlErrors.optionsZero;
        }
      } else if (ctrl.props.options.length > 2) {
        return ctrlErrors.optionsTwo;
      }
    }
  }

  // NUMBER
  if (isNumberCtrl) {
    const numberError = validateNumberCtrl(ctrl.props);
    if (numberError) return numberError;
  }

  // EMBED
  if (ctrl.type === ControlType.EMBED_FIELD) {
    const url = ctrl.props?.url?.trim();

    if (!url) {
      return ctrlErrors.empty_url;
    }

    // Check if the URL is valid
    if (!urlTestPattern.test(url)) {
      return ctrlErrors.invalid_url;
    }

    // Check if the URL is in the list of approved URLs
    const allowedURLsRegex = /^(https:\/\/)?(www\.)?(youtube.com\/watch\?v|vimeo\.com|cincopa\.com)/;
    if (!allowedURLsRegex.test(url)) {
      return ctrlErrors.unapproved_url;
    }
  }

  // MATRIX RATING
  if (ctrl.type === ControlType.MATRIX_RATING) {
    const checkBlankHeaders = (headers) => {
      for (const value of headers) {
        if (!value || /^\s*$/.test(value)) return true;
      }
      return false;
    };

    const checkSimilarValues = (headers) => {
      const cleanedHeaders = headers.map((h) => h.trim());
      const uniqueValues = new Set(cleanedHeaders);
      return uniqueValues.size !== cleanedHeaders.length;
    };

    if (ctrl.props.column_headers.length) {
      const hasBlankLine = checkBlankHeaders(ctrl.props.column_headers);
      const hasSimilarValues = checkSimilarValues(ctrl.props.column_headers);

      if (hasBlankLine) return ctrlErrors.blank_matrix_headers;
      if (hasSimilarValues) return ctrlErrors.similar_matrix_headers;
    }

    if (ctrl.props.row_headers.length) {
      const hasBlankLine = checkBlankHeaders(ctrl.props.row_headers);
      const hasSimilarValues = checkSimilarValues(ctrl.props.row_headers);

      if (hasBlankLine) return ctrlErrors.blank_matrix_headers;
      if (hasSimilarValues) return ctrlErrors.similar_matrix_headers;
    }

    if (ctrl.props.column_headers.length > 15) {
      return ctrlErrors.column_headermax;
    }

    if (ctrl.props.row_headers.length > 15) {
      return ctrlErrors.row_headermax;
    }
  }

  // IMAGE CHOICES
  if (ctrl.type === ControlType.IMAGE_CHOICE) {
    if (ctrl.props.options.length === 0) {
      return ctrlErrors.imageOptions;
    }

    for (let j = 0; j < ctrl.props.options.length; j += 1) {
      if (!ctrl.props.options[j]) {
        return ctrlErrors.imagelabel_empty;
      }
    }
  }

  // PAYMENT
  if (vm.fields.includes(ctrl.type)) {
    if (ctrl.props.amount <= 0) {
      return ctrlErrors.amount_empty;
    }

    if (ctrl.props.required) {
      checkCred(ctrl.type);
      const paymentType = `${ctrl.type.charAt(0).toUpperCase()}${ctrl.type.substr(1)}`;
      if (vm.missing_credentials.includes(paymentType)) {
        return `${paymentType} ${ctrlErrors.payment_required} ${paymentType} ${ctrlErrors.payment_credential}`;
      }
    }
  }

  // PAYMENT - PAYPAL CURRENCIES NO DECIMALS
  const nonDecimals = ['TWD', 'JPY', 'HUF'];
  const decimalRegex = /^\d+\.(([1-9][0-9]*)|([0-9][1-9]*))$/;
  if (
    ctrl.type === ControlType.PAYPAL &&
    nonDecimals.indexOf(ctrl.props.currency) > -1 &&
    decimalRegex.test(ctrl.props.amount)
  ) {
    return `${ctrlErrors.nodecimal_support} ${ctrl.props.currency} ${ctrlErrors.paypal_err}`;
  }

  // DESCRIPTION
  if (ctrl.type === ControlType.DESCRIPTION) {
    if (ctrl.props.text.replace(/\s/g, '').includes('<script>')) {
      return ctrlErrors.description;
    }
  }

  // LOOKUP
  if (ctrl.type === ControlType.LOOKUP) {
    if (ctrl.props.source_field_ids && ctrl.props.dest_field_ids) {
      if (!isArrayValuesUnique(ctrl.props.source_field_ids) || !isArrayValuesUnique(ctrl.props.dest_field_ids)) {
        return ctrlErrors.unique_field;
      }

      if (ctrl.props.source_field_ids.length !== ctrl.props.dest_field_ids.length) {
        return ctrlErrors.unequal_source_to_destination;
      }

      if (
        !ctrl.props.form ||
        !ctrl.props.form_field ||
        (ctrl.props.lookup_type == 1 &&
          (!ctrl.props.source_field_ids?.length ||
            !ctrl.props.dest_field_ids?.length ||
            ctrl.props.source_field_ids[0]?.indexOf('init') === 0 ||
            ctrl.props.dest_field_ids[0]?.indexOf('init') === 0))
      ) {
        return 'Lookup setup is incomplete';
      }
    }
  }

  // DATE/DATE-TIME
  if (ctrl.props.min_date && ctrl.props.max_date) {
    if (new Date(ctrl.props.min_date) > new Date(ctrl.props.max_date)) {
      return ctrlErrors.min_date;
    }
  }

  // TIME/DATE-TIME
  if (ctrl.props.min_time && ctrl.props.max_time) {
    if (ctrl.props.min_time.split(':')[0] > ctrl.props.max_time.split(':')[0]) {
      return ctrlErrors.min_time;
    }

    if (ctrl.props.min_time.split(':')[0] === ctrl.props.max_time.split(':')[0]) {
      if (ctrl.props.min_time.split(':')[1] > ctrl.props.max_time.split(':')[1]) {
        return ctrlErrors.min_time;
      }
    }
  }

  // FILE UPLOAD
  if (ctrl.type === ControlType.FILE_UPLOAD && ctrl.props.rename.enabled && !ctrl.props.rename.internal_id) {
    return ctrlErrors.no_rename_internalId;
  }

  // ROW
  if (ctrl.type === ControlType.ROW) {
    if (ctrl.props.controls.length === 0) {
      return 'Row must contain at least one field';
    }
  }

  // TABLE
  if (ctrl.type === ControlType.TABLE_FIELD) {
    const hasBlankColumnHeader = ctrl.props.column_headers.some((header) => /^\s*$/.test(header));

    if (hasBlankColumnHeader) return ctrlErrors.nocol_name;

    if (ctrl.props.min_rows < 1) {
      return ctrlErrors.row_empty;
    }

    if (ctrl.props.max_rows < 1) {
      return ctrlErrors.resrow_empty;
    }

    if (ctrl.props.min_rows > 50) {
      return ctrlErrors.row_exceeded;
    }

    if (ctrl.props.max_rows > 50) {
      return ctrlErrors.resrow_exceeded;
    }

    // Validate fields in table/table props
    if (ctrl.table_props) {
      for (let i = 0; i < ctrl.table_props.length; i += 1) {
        const tableProp = ctrl.table_props[i];
        if (ctrl.props.column_types.includes('text_input')) {
          if (tableProp.min_length && tableProp.max_length) {
            if (tableProp.min_length > tableProp.max_length) {
              return `${ctrlErrors.min_max} (Check column ${i + 1})`;
            }
          }
        }

        if (ctrl.props.column_types.includes('number_input')) {
          const numberError = validateNumberCtrl(tableProp, i + 1);
          if (numberError) return numberError;
        }
      }
    }
  }

  // INVENTORY
  if (ctrl.type === ControlType.INVENTORY) {
    if (ctrl.props.accept_inventory_payment && !ctrl.props.inventory_payment_type) {
      return ctrlErrors.payment_merchant_is_required;
    }
  }

  return null;
};

export const validateFormFields = () => (dispatch, getState) => {
  const { builderForm: form } = getState().builder.present;
  const newForm = cloneDeep(form);

  const { pages, pageIds } = newForm;
  const errorPages = new Set();
  const errorCtrls = [];
  const errorIds = [];
  let errShownCount = 0;

  const errorMsgFields = (pagesStr) => (errShownCount ? errorMsgPageMultiple(pagesStr) : errorMsgPageOnce(pagesStr));

  dispatch(disableHandler());

  newForm.name = htmlToPlainText(form.name);

  pages.forEach((page, pageIndex) => {
    pageIds[pageIndex].forEach((fieldId) => {
      const ctrl = page[fieldId];
      const validationError = dispatch(validateCtrl(ctrl));
      if (validationError) {
        ctrl._validationError = validationError;
        errorPages.add(pageIndex + 1);
        errorCtrls.push(ctrl);
        errorIds.push(ctrl.internal_id);
        dispatch(showFieldError({ ctrl, index: pageIndex }));
      }
    });
  });

  const noErrors = errorIds.length === 0;
  errShownCount += 1;

  const errorPageList = [...errorPages].join(', Page ');

  return [noErrors, errorMsgFields(errorPageList)];
};

function getUnsupportedFields(form, remove) {
  const restrictedFields = ['pages', 'name'];
  const unsupportedFields = [];

  for (const field of Object.keys(form)) {
    if (!restrictedFields.includes(field)) {
      const isSupported = planSupportField(field);
      if (!isSupported && form[field].length > 0) {
        if (remove) form[field] = [];
        else unsupportedFields.push(field);
      }
    }
  }

  return unsupportedFields;
}

function getUnsupportedPageControls(pages, remove) {
  let unsupportedControls = [];

  for (const page of pages) {
    const unsupportedIndexes = page.controls.reduce((acc, control, idx) => {
      if (!planSupportField(control.type)) acc.push(idx);
      return acc;
    }, []);

    if (remove) {
      page.controls = page.controls.filter((_, idx) => !unsupportedIndexes.includes(idx));
    }

    unsupportedControls = unsupportedControls.concat(unsupportedIndexes);
  }

  return unsupportedControls;
}

export const processPremiumControls =
  (remove = false, form = null) =>
  (dispatch, getState) => {
    const { builderForm } = getState().builder.present;
    const fullForm = form || ammendBuilderForm(builderForm);
    const premiumKeys = getUnsupportedFields(fullForm, remove);
    const premiumControlIndexes = getUnsupportedPageControls(fullForm.pages, remove);

    const isPremium = premiumKeys.length > 0 || premiumControlIndexes.length > 0;
    dispatch(updateCredential({ isPremium }));

    return fullForm;
  };

export const presendParsing = (form, autosave) => (dispatch, getState) => {
  const { form: oldForm, builderForm, addRowCtrls } = getState().builder.present;
  const tempForm = cloneDeep(form);
  const allLookupForms = [];
  const copiedaddRowControls = cloneDeep(addRowCtrls);
  for (let r = 0; r < tempForm.definition.pages.length; r += 1) {
    tempForm.definition.pages[r].controls = pageReorderControl(tempForm.definition.pages[r], copiedaddRowControls);
  }
  // clear phone codes and set default labels
  for (let p = 0; p < tempForm.definition.pages.length; p += 1) {
    for (let c = 0; c < tempForm.definition.pages[p].controls.length; c += 1) {
      const ctrl = form.definition.pages[p].controls[c];

      if (!ctrl) continue;

      ctrl.props.label = ctrl.props.label || ctrlDefaults()[ctrl.type];
      if (ctrl.phoneCodes) {
        delete ctrl.phoneCodes;
      }

      if (
        ctrl.type === 'select_basic' ||
        ctrl.type === 'select_multiple' ||
        ctrl.type === 'matrix_rating' ||
        ctrl.type === 'table_field' ||
        ctrl.type === 'image_choice' ||
        ctrl.type === 'lookup'
      ) {
        ctrl.value = null;
      }

      if (ctrl.props.phone_valid_codes) {
        for (let i = 0; i < ctrl.props.phone_valid_codes.length; i += 1) {
          if (ctrl.props.phone_valid_codes[i].code) {
            ctrl.props.phone_valid_codes[i] = ctrl.props.phone_valid_codes[i].code;
          } else {
            // ctrl.props.phone_valid_codes[i] = ctrl.props.phone_valid_codes[i]
          }
        }
      }

      if (ctrl.type === 'lookup' && oldForm) {
        const lookupDetails = {
          form_with_lookup_field: oldForm.id,
          form_to_lookup_from: ctrl.props.form,
          field_to_lookup: ctrl.props.form_field,
          lookup_form_name: oldForm.name,
        };
        allLookupForms.push(lookupDetails);
      }

      if (!ctrl.internal_id) ctrl.internal_id = newIdentifier(Object.keys(builderForm.identifiers));
      if (!ctrl.display_id) ctrl.display_id = ctrl.internal_id;
    }
  }

  tempForm.lookupForms = allLookupForms;
  if (autosave) return tempForm;
  for (let q = tempForm.definition.pages.length - 1; q >= 0; q -= 1) {
    if (tempForm.definition.pages[q].controls.length === 0) {
      tempForm.definition.pages.splice(q, 1);
    }
  }
  tempForm.definition = dispatch(processPremiumControls(true, tempForm.definition));

  return tempForm;
};

const validateTimerAndPaymentConstraints = () => async (dispatch, getState) => {
  const { isTemplateForm, enableTimer, isNewForm, form } = getState().builder.present;
  if (isTemplateForm || isNewForm || !form?.id) return false;

  const hasPaymentField = await dispatch(checkPaymentFields());
  if (!enableTimer && !hasPaymentField) return false;

  const trueForm = await fetchTrueForm(form.id);
  const isSubmitHidden = trueForm?.options?.hide_submit_button;
  if (!isSubmitHidden) return false;

  const message =
    enableTimer && hasPaymentField
      ? 'Timer and payment fields cannot be added when the submit button is disabled'
      : enableTimer
      ? 'Timer cannot be added when the submit button is disabled'
      : 'Payment fields cannot be added when the submit button is disabled';

  toast.error(message);
  return true;
};

export const internalSaveForm = (isNewForm) => async (dispatch, getState) => {
  const {
    enableClosingPage,
    enableESignature,
    enableIntroPage,
    timerOptions,
    closingPages,
    introDetails,
    builderForm,
    enableTimer,
    form,
  } = getState().builder.present;

  const formMetaData = {};

  if (!formHasControls(builderForm)) {
    dispatch(
      showFormError({
        formError: `You can't save an empty form. Please add some form fields to your form and then save.`,
      })
    );
    return;
  }

  const hasTimerAndPaymentConstraints = await dispatch(validateTimerAndPaymentConstraints());
  if (hasTimerAndPaymentConstraints) return;

  dispatch(savingForm(true));
  const invalidForm = dispatch(validateFormFields());

  if (!invalidForm[0]) {
    dispatch(showFormError({ formError: invalidForm[1] }));
    dispatch(savingForm(false));
    return;
  }

  const newForm = ammendBuilderForm(builderForm);
  const { formJ, metaData } = checkWideForm(newForm, formMetaData);
  const storableClosingPages = convertToStorableClosingPages(closingPages);

  const options = {
    enable_closing_page: enableClosingPage,
    enable_esignature: enableESignature,
    enable_intro_page: enableIntroPage,
    timer_options: timerOptions,
    enable_timer: enableTimer,
  };

  let fullForm = {
    description: builderForm.description,
    closing_pages: storableClosingPages,
    definition: formJ,
    ...introDetails,
    options,
    ...(isNewForm && {
      origin_form_id: form?.id || null,
      origin_template_form_id: null,
      origin_templatemodel_id: null,
      metadata: metaData,
      id: '_NEW_',
    }),
  };

  fullForm = dispatch(presendParsing(fullForm));

  const handleErrorResponse = (response) => {
    dispatch(savingForm(false));
    dispatch(showBuilderError(`${response.error} please contact support.`));
    console.error(response.error);

    if (response.status === '403' && response.error.includes('form is inactive')) {
      dispatch(indicateFormDeactivation(true));
    }

    const knownErrorMessages = ['You cannot create more forms than your plan allows'];

    const defaultErrorMessage = `There was is an issue with saving this form. please contact support.`;
    const knownErrorMessage = knownErrorMessages.find((msg) => response.error.includes(msg));
    const errorMessage = knownErrorMessage || defaultErrorMessage;
    toast.error(errorMessage);
  };

  const method = isNewForm ? 'POST' : 'PUT';
  const url = isNewForm ? '/api/v2/user/form' : `/api/v2/user/form/${form.id}`;

  const data = isNewForm ? apiCommon({ form: fullForm }) : apiCommon({ form_id: form.id, form: fullForm });

  fplsFetch({ method, url, data })
    .then((response) => {
      if (response.error) return handleErrorResponse(response);
      dispatch(doSuccess(response, isNewForm ? undefined : form.id));
      dispatch(setIsBuilderFormUpdated(false));
    })
    .catch((err) => dispatch(doError(err, fullForm)));
};

export const showPaymentNag = (isNewForm) => async (dispatch, getState) => {
  await dispatch(checkFormHasPaymentField());
  dispatch(saveAction({ create: isNewForm }));

  const { showNag } = getState().formValidations.vm;

  if (showNag) {
    dispatch(paymentCredentialMissingModal(true));
    return;
  }

  dispatch(internalSaveForm(isNewForm));
};

export const removePremium = (isNewForm) => (dispatch, getState) => {
  const { isPremium, plan } = getState().formValidations;

  dispatch(processPremiumControls());
  dispatch(saveAction({ create: isNewForm }));

  if (plan.trial_eligible && isPremium) {
    dispatch(showClearPremiumModal(true));
  }
};

export const resolvePremiumAccess = (isNewForm) => async (dispatch, getState) => {
  const { isPremium, plan } = getState().formValidations;
  const userId = win.USER_ID;

  dispatch(removePremium(isNewForm));

  if (isPremium && plan.is_free) {
    if (plan.trial_eligible) {
      try {
        const response = await fplsFetch({
          method: 'PUT',
          url: `/api/v2/user/${userId}/upgrade_to_trial`,
        });
        dispatch(updatePlan(response.data.plan));
        dispatch(showPaymentNag(isNewForm));
      } catch (error) {
        console.error('Upgrade Free plan error', error);
        dispatch(
          showFormError({
            formError: 'Upgrade Free plan error',
          })
        );
      }
    } else {
      dispatch(
        showFormError({
          formError: 'Cannot use template with premium fields. Please upgrade.',
        })
      );
    }
  } else {
    dispatch(showPaymentNag(isNewForm));
  }
};

export const doSaveForm = (isNewForm) => (dispatch, getState) => {
  const { builderForm } = getState().builder.present;

  const formName = builderForm.name;
  const isEmptyName = typeof formName !== 'string' || /^\s*$/.test(formName);

  if (isEmptyName) {
    dispatch(doShowFormNameModal(true));
    return;
  }

  dispatch(resolvePremiumAccess(isNewForm));
};

export const doFetchPDFForm = () => async (dispatch) => {
  const form = getPDFForm();
  const error = 'Failed to fetch PDF form. Please try again.';
  if (!form) {
    dispatch(showFormError({ formError: error }));
    return;
  }
  const { undoReducers } = form;
  const { present } = undoReducers;
  const { elementIds, elements } = present.element.pageElements;
  const pdfElementCtrls = [];
  const propsTypeArray = ['short_text', 'labeled_input', 'datetime', 'text_input'];

  for (let e = 0; e < elementIds.length; e += 1) {
    const elementId = elementIds[e];
    const elementCtrl = elements[elementId];
    if (elementCtrl.type === 'datetime' && !elementCtrl.props?.time_section) {
      elementCtrl.props.type = 1;
    } else if (propsTypeArray.includes(elementCtrl.type)) {
      elementCtrl.props.type = 0;
    }
    if (
      elementCtrl.props.time_section === true &&
      !(elementCtrl.props.day_section && elementCtrl.props.month_section && elementCtrl.props.year_section)
    ) {
      elementCtrl.props.type = 2;
    }
    if (elementCtrl.type === 'signature') {
      elementCtrl.props.rename = { enabled: false, internal_id: '' };
      elementCtrl.props.hidden = false;
    }

    let filename = '';
    let gcsUrl = '';
    if (elementCtrl.type === 'media_image') {
      const dataUrl = elementCtrl.props.upload_image;
      if (dataUrl) {
        filename = `${elementCtrl.internal_id}.png`;
        try {
          gcsUrl = localStorage.getItem(filename) || '';
        } catch (err) {
          console.error('Gettng PDF image name from Localstorage Error', err);
        }
        if (!gcsUrl) {
          gcsUrl = await uploadPDFImgToServer(dataUrl, filename);
        }
        elementCtrl.props.upload_image = gcsUrl;
      }
    } else if (elementCtrl.type === 'image_choice') {
      const dataUrls = elementCtrl.props.images;
      for (let u = 0; u < dataUrls.length; u++) {
        const url = dataUrls[u];
        if (url) {
          filename = `${elementCtrl.internal_id}_${u}.png`;
          try {
            gcsUrl = localStorage.getItem(filename) || '';
          } catch (err) {
            console.error('Getting PDF image name from Localstorage Error', err);
          }
          if (!gcsUrl) {
            gcsUrl = await uploadPDFImgToServer(url, filename);
          }
          dataUrls[u] = gcsUrl;
        }
      }
    } else if (elementCtrl.type === 'table_field') {
      const types = elementCtrl.props.column_types;
      for (let t = 0; t < types.length; t++) {
        const type = types[t];
        if (type === 'datetime') {
          const tableProp = elementCtrl.table_props[t];
          if (!tableProp.hasOwnProperty('default')) {
            tableProp.default = '';
          }
          if (!tableProp.hasOwnProperty('label')) {
            tableProp.label = 'Date and Time';
          }
          if (!tableProp.hasOwnProperty('hidden')) {
            tableProp.hidden = false;
          }
          if (!tableProp.hasOwnProperty('readonly')) {
            tableProp.readonly = false;
          }
          if (!tableProp.hasOwnProperty('separator')) {
            tableProp.separator = '/';
          }
          if (!tableProp.hasOwnProperty('type')) {
            tableProp.type = 0;
          }
        }
      }
    } else if (elementCtrl.type === 'add_row') {
      elementCtrl.is_row = false;
      const controls = cloneDeep(elementCtrl.props.controls);
      for (let c = 0; c < controls.length; c++) {
        const ctrl = controls[c];
        elementCtrl.props.controls[c] = ctrl.internal_id;
        ctrl.is_row = true;
        pdfElementCtrls.push(ctrl);
      }
    }
    pdfElementCtrls.push(elementCtrl);
  }
  const formData = {
    name: present?.element?.pageInfo?.pdfName,
    definition: {
      calculations: [],
      rules: [],
      pages: [
        {
          controls: pdfElementCtrls,
          internal_id: newIdentifier(present?.element?.pageElements?.elementIds),
        },
      ],
    },
  };
  dispatch(fetchPDFSuccess(formData));
};

export const route2PDFForm = () => async (dispatch) => {
  const exceeded = await dispatch(checkQuotas());
  if (exceeded) return;
  dispatch(doFetchPDFForm());
};
